import React from 'react'
import * as S from './TableProducts.styles'
import { NumberFmt } from '../../../../../../../utils'

function TableProducts({ tableData, handleDeleteRow }) {
  return (
    <S.Table>
      <S.THead>
        <S.THeadTR>
          <S.TH>Deletar</S.TH>
          <S.TH>Código de barras</S.TH>
          <S.TH>Descrição</S.TH>
          <S.TH>Unid.</S.TH>
          <S.TH>Avariados</S.TH>
          <S.TH>Validade</S.TH>
        </S.THeadTR>
      </S.THead>
      <S.TBody>
        {tableData.map((row) => (
          <S.TBodyTR key={row.batchId}>
            <S.TD>
              <S.TrashButton handleClick={() => handleDeleteRow(row)} />
            </S.TD>
            <S.TD>{row.barcode}</S.TD>
            <S.TD>{row.description}</S.TD>
            <S.TDRight>
              <NumberFmt
                value={row.total}
                sufix={row.measureUnit.isKg ? 'KG' : 'UN'}
                digits={row.measureUnit.isKg ? 3 : 0}
              />
            </S.TDRight>
            <S.TDRight data-testid="qtd-avaria">
              <NumberFmt
                value={row.damageQuantity}
                sufix={row.measureUnit.isKg ? 'KG' : 'UN'}
                digits={row.measureUnit.isKg ? 3 : 0}
              />
            </S.TDRight>
            <S.TD>{row.expirationDate.format('DD/MM/YYYY')}</S.TD>
          </S.TBodyTR>
        ))}
      </S.TBody>
    </S.Table>
  )
}

export default TableProducts
